import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import module_auth from '@/modules/auth';
import module_onboard from '@/modules/onboarding';
import module_payroll from '@/modules/payroll';
import module_dashboard from '@/modules/dashboard';
import module_globalapis from '@/modules/globalapis/';
// import loggerPlugin from './plugins/logger';
import router from '@/router';

Vue.use(Vuex);

let state = {
  brandName: 'Paylief',
}

let mutations = {

};

let actions = {
  routeTo( payload){
    router.push(payload);
  }
};

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    auth: module_auth.store,
    onboard: module_onboard.store,
    payroll: module_payroll.store,
    dashboard: module_dashboard.store,
    globalapi: module_globalapis.store
  },
  plugins: [ createPersistedState()]
});

export default store;
